export default __webpack_public_path__ + "static/media/settings_card.f8a5b993.svg";